const { connect } = require("react-redux");
const Header = require("components/Header");
const AuthActions = require("actions/auth");

module.exports = connect(
    state => ({
        numCredits:
            state.auth.credentials.user && state.auth.credentials.user.credits,
        isAuthenticated: state.auth.isAuthenticated,
        isAdmin:
            state.auth.isAuthenticated && state.auth.credentials.user.isAdmin
    }),
    {
        logout: AuthActions.logout
    }
)(Header);



// WEBPACK FOOTER //
// ./src/containers/Header.js